import React, { useEffect, useState } from 'react'
import { Btn, CustomCalendar } from '../'
import { getPeriodoMesAtual } from '../../services/util/date.service'
import './Periodo.css'
import { DateTime } from 'luxon'

const { dataInicial, dataFinal } = getPeriodoMesAtual()

function Periodo({
  btnEnabled = true,
  onPesquisar,
  periodoInicial = dataInicial,
  periodoFinal = dataFinal,
  isLoading = false,
  textPesquisar = 'Pesquisar',
  onChangePeriodoInicial,
  onChangePeriodoFinal,
  showButton = true,
}) {
  // Hooks
  const [pInicial, setPeriodoInicial] = useState(periodoInicial)
  const [pFinal, setPeriodoFinal] = useState(periodoFinal)

  useEffect(() => {
    if (periodoInicial) {
      setPeriodoInicial(periodoInicial)
    }
    if (periodoFinal) {
      setPeriodoFinal(periodoFinal)
    }
  }, [periodoInicial, periodoFinal])

  const setTimeToEndOfDay = value => {
    return DateTime.fromJSDate(value).set({ hour: 23, minute: 59, second: 59 }).toJSDate()
  }

  const handlePeriodoInicialChange = value => {
    setPeriodoInicial(value)
    if (onChangePeriodoInicial) {
      onChangePeriodoInicial(value)
    }
  }

  const handlePeriodoFinalChange = value => {
    const finalValue = setTimeToEndOfDay(value)
    setPeriodoFinal(finalValue)
    if (onChangePeriodoFinal) {
      onChangePeriodoFinal(finalValue)
    }
  }

  // Render
  return (
    <div className="Periodo">
      <CustomCalendar
        label="Período Inicial"
        value={pInicial}
        onChange={handlePeriodoInicialChange}
      />
      <CustomCalendar label="Período Final" value={pFinal} onChange={handlePeriodoFinalChange} />
      {showButton && (
        <div style={{ marginLeft: 10, paddingTop: 27 }}>
          <Btn
            disabled={!btnEnabled}
            isLoading={isLoading}
            onClick={() => onPesquisar(pInicial, pFinal)}
          >
            {textPesquisar}
          </Btn>
        </div>
      )}
    </div>
  )
}

export default Periodo
